<template>
  <div class="score-list">
    <div v-for="row in rows" :key="row.key" class="score-row" :class="{'score-lowest': row.lowest}">
      <div class="score-head"><span>{{row.label}}</span><strong>{{row.value}}/10</strong></div>
      <div class="score-track" role="progressbar" :aria-label="row.label" aria-valuemin="0" aria-valuemax="10" :aria-valuenow="row.value">
        <span class="score-fill" :style="{width: row.value * 10 + '%'}"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: { rows: { type: Array, default: () => [] } }
}
</script>
